type AuthUser = {
  name: string;
  account: string;
  avatarUrl: string;
};

/* eslint-disable @typescript-eslint/no-unused-vars */
export async function signIn(account: string, password: string) {
  try {
    const response = await fetch('/api/auth/login', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ account, password }),
    });
    if (!response.ok) {
      return {
        isOk: false,
        message: response.status === 401 ? 'Tài khoản hoặc mật khẩu không đúng' : 'Không thể đăng nhập. Vui lòng thử lại.',
      };
    }

    return { isOk: true, data: await response.json() as AuthUser };
  } catch {
    return { isOk: false, message: 'Không thể kết nối máy chủ đăng nhập.' };
  }
}

export async function getUser() {
  try {
    const response = await fetch('/api/auth/session', { credentials: 'same-origin' });
    if (!response.ok) {
      return { isOk: false };
    }
    const session = await response.json();
    if (!session.authenticated) {
      return { isOk: false };
    }
    return { isOk: true, data: session.user as AuthUser };
  } catch {
    return { isOk: false };
  }
}

export async function signOut() {
  try {
    await fetch('/api/auth/logout', {
      method: 'POST',
      credentials: 'same-origin',
    });
  } catch {
    // Clear the local authenticated view even if the server cannot be reached.
  }
}

export async function createAccount(email: string, password: string) {
  try {
    return { isOk: true };
  } catch {
    return { isOk: false, message: 'Failed to create account' };
  }
}

export async function changePassword(email: string, recoveryCode?: string) {
  try {
    return { isOk: true, data: { email } };
  } catch {
    return { isOk: false, message: 'Failed to change password' };
  }
}

export async function resetPassword(email: string) {
  try {
    return { isOk: true };
  } catch {
    return { isOk: false, message: 'Failed to reset password' };
  }
}
